"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TrackingPixelCodes = _interopRequireDefault(require("./TrackingPixelCodes"));

var _TrackingPixel = _interopRequireDefault(require("./TrackingPixel"));

var fbEventTypes = {
  FORM_SUBMITTED: 'ViewContent',
  PORTAL_CREATED: 'CompleteRegistration',
  ACTIVATED: 'InitiateCheckout',
  WAU: 'Lead'
};
var TrackingPixelUtils = {
  trackSignupFlow: function trackSignupFlow() {
    _TrackingPixel.default.twitterAds(_TrackingPixelCodes.default.TWITTER_ADS_SIGNUP_FORM);

    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.FORM_SUBMITTED);

    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.FORM_SUBMITTED);

    return _TrackingPixel.default.bing(_TrackingPixelCodes.default.BING_ADS);
  },
  trackCreatedPortal: function trackCreatedPortal() {
    _TrackingPixel.default.googleAdwords();

    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.PORTAL_CREATED);

    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.PORTAL_CREATED);

    _TrackingPixel.default.quora(_TrackingPixelCodes.default.QUORA_USER_CREATE);

    return _TrackingPixel.default.clickMeter(_TrackingPixelCodes.default.CLICKMETER_CRM_SIGNUP);
  },
  trackUserActivation: function trackUserActivation() {
    _TrackingPixel.default.googleAdwords(_TrackingPixelCodes.default.GOOGLE_ADSWORDS_ACTIVATION);

    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.ACTIVATED);

    return _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.ACTIVATED);
  },
  trackPortalActivation: function trackPortalActivation() {},
  // not in use
  trackActiveUser: function trackActiveUser() {
    _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.WAU);

    return _TrackingPixel.default.facebookCategory(_TrackingPixelCodes.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.WAU);
  }
};
var _default = TrackingPixelUtils;
exports.default = _default;
module.exports = exports.default;